import { listProps } from "../utils/helper";

export const traceManagementInitialState = {

  traceQueueData: null,
  traceQueueDataError: null,
  closeOrSendTraceQueueData: null,
  closeOrSendTraceQueueError: null,
  readTraceMessagesData: null,
  readTraceMessagesError: null
};

export default function traceManagementReducer(
  state = traceManagementInitialState,
  action
) {
  switch (action.type) {

    case "GET_TRACE_QUEUE_SUCCESS":
      return {
        action: action.type,
        traceQueueData: action.data.data,
        traceQueueDataError: null,
        traceQueueDetails: action.data.traceQueueDetails,
      };
      
    case "GET_TRACE_QUEUE_ERROR":
      return {
        action: action.type,
        traceQueueData: null,
        traceQueueDataError: action.error };

    case "CLOSE_TRACE_FOR_TRACE_QUEUE_SUCCESS":
      return {
        ...state,
        action: action.type,
        closeOrSendTraceQueueData: action.data,
        closeOrSendTraceQueueError: null
      };
    case "CLOSE_TRACE_FOR_TRACE_QUEUE_FAILURE":
      return {
        ...state,
        action: action.type,
        closeOrSendTraceQueueData: null,
        closeOrSendTraceQueueError: action.error
      };
    case "SEND_TRACE_FOR_TRACE_QUEUE_SUCCESS":
      return {
        ...state,
        action: action.type,
        closeOrSendTraceQueueData: action.data,
        closeOrSendTraceQueueError: null
      };
    case "SEND_TRACE_FOR_TRACE_QUEUE_FAILURE":
      return {
        ...state,
        action: action.type,
        closeOrSendTraceQueueData: null,
        closeOrSendTraceQueueError: action.error
      };
    case "READ_TRACE_MESSAGES_SUCCESS":
      return {
        ...state,
        action: action.type,
        readTraceMessagesData: action.data?.data,
        readTraceMessagesError: null};
      
    case "READ_TRACE_MESSAGES_FAILURE":
      return {
        ...state,
        action: action.type,
        readTraceMessagesError: action.error,
        readTraceMessagesData: null};

    default:
      return state;
  }
}